import styled from "styled-components";
import { 
  Form as AntForm,
  Typography as AntTypography, 
  Input as AntInput,
  Button as AntButton,
} from "antd";
import { BackArrow } from '@assets';
import { AuthBg, AuthLogo } from "@assets/auth";
import lightTheme from '@styles/theme';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 37px;
  height: 37px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 25px;
  height:25px;
`;

export const SkipButton = styled(AntButton)`
  display: inline-flex;
  padding: 7px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  background-color: #212224;

  color: #FFB829;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px auto 24px;
`

export const Title = styled(AntTypography.Title)`
  margin: 0 0 33px 0 !important;
  color: #FFC654 !important;
  text-align: center;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal !important;
` 

export const Form = styled(AntForm)`
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px !important;
  }

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    margin: 0px 0 6px 8px;
    margin-left: 8px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #DADADA;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  input {
    height: 52px;
    border-radius: 12px;
  }

  .ant-btn-primary {
    height: 56px;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  text-align: left;
  padding-left: 17px;
  color: #0E1017;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  
`;


